import { PropsWithoutRef } from 'react';
import { Link as GatsbyLink, type GatsbyLinkProps } from 'gatsby';
import { cn } from 'services/cn';

export interface LinkProps<TState = {}> extends PropsWithoutRef<GatsbyLinkProps<TState>> {
    isBrand?: boolean;
    isMedium?: boolean;
    isNote?: boolean;
    isExternal?: boolean;
};

export const Link = ({ isExternal, to, children, activeClassName, partiallyActive, isBrand, isMedium, isNote, ...props }: LinkProps) => {
    const className = cn(
        {
            'tw:text-body': !isNote,
            'tw:text-note': isNote,
            'tw:font-medium': isMedium,
            'tw:text-blue-700 tw:dark:text-blue-400': isBrand,
        },
        'tw:hover:text-blue-700 tw:hover:underline tw:visited:text-purple-800 tw:dark:visited:text-purple-300',
        'tw:focus-visible:outline-1 tw:outline-blue-800 tw:dark:outline-blue-600 tw:rounded-sm tw:underline',
        props.className,
    );

    const internal = /^\/(?!\/)/.test(to);

    if (internal && !isExternal) {
        return (
            <GatsbyLink to={to} activeClassName={activeClassName} partiallyActive={partiallyActive} {...props} className={className} >
                {children}
            </GatsbyLink>
        );
    }

    return (
        <a href={to} {...props} className={className} rel={`${isExternal ? 'noopener noreferrer ' : ''}${props.rel ? props.rel : ''}`} target={`${isExternal ? '_blank ' : ''}${props.target ? props.target : ''}`} aria-label={`Navigate to ${to}`} >
            {children}
        </a>
    );
};
